import {createSlice} from "@reduxjs/toolkit";

const initialState = {}


const dtSlice = createSlice({
    name: 'datatable',
    initialState,
    reducers: {
        dtSetFilters: (state, action) => {
            const dt = state?.[action?.payload?.name]
                ? {...state[action?.payload?.name]}
                : {}
            dt.filters = action.payload.filters
            dt.page = 1
            dt.timestamp = Date.now()
            return {
                ...state, [action.payload.name]: dt
            }
        },
        dtSetPage: (state, action) => {

            const dt = state?.[action?.payload?.name]
                ? {...state[action?.payload?.name]}
                : {}
            dt.page = action.payload.page
            dt.timestamp = Date.now()
            return {
                ...state, [action.payload.name]: dt
            }
        },
        dtSetLimit: (state, action) => {
            const dt = state?.[action?.payload?.name]
                ? {...state[action?.payload?.name]}
                : {}
            dt.limit = action.payload.limit
            dt.page = 1
            dt.timestamp = Date.now()
            return {
                ...state, [action.payload.name]: dt
            }
        },
        dtSetSort: (state, action) => {
            const dt = state?.[action?.payload?.name]
                ? {...state[action?.payload?.name]}
                : {}
            dt.sort = action.payload.sort
            dt.page = 1
            dt.timestamp = Date.now()
            return {
                ...state, [action.payload.name]: dt
            }
        },

        dtClear: (state, action) => {
            const dt = state?.[action?.payload?.name]
                ? {...state[action?.payload?.name]}
                : {}
            dt.filters = {}
            dt.page = 1
            dt.timestamp = Date.now()
            return {
                ...state, [action.payload.name]: dt
            }
        }
    }
})

export const {dtSetFilters, dtSetPage, dtSetLimit, dtSetSort, dtClear} = dtSlice.actions
export default dtSlice.reducer
